<ng-container *ngIf="files$ | async as step">
  <prlw-file-upload *ngIf="step === 'Preload'"></prlw-file-upload>
  <prlw-attachments-files *ngIf="step === 'Uploaded'"></prlw-attachments-files>
</ng-container>
